import { Link } from "gatsby";
import React from "react";
import * as Animate from "react-reveal"
export default function ArticleCard({ feature }) {
    return (
        <Link
            to={feature.link}
            target="_blank"
            rel='noopener noreferrer'
            className="w-full rounded-lg overflow-hidden bg-[#fff] cstm-article-shadow mt-4 new-card"
        >
            <div className="w-full object-cover">
                <img
                    className="w-full h-full object-cover"
                    src={feature.image}
                    alt={feature.source}
                />
            </div>

            <div className="flex  flex-col px-3 lg:px-3 pt-6 gap-y-8 pb-8 lg:pb-10">
                <div className="text-lg lg:text-lg  font-medium md:text-base capitalize h-16">
                    <h4 className="two-line-clip">{feature.caption}</h4>
                </div>
                <div className="flex flex-row justify-between items-center text-xs text-cstm-grey">
                    <img
                        className={`${feature.source === "VENTURES AFRICA" ? "max-h-4" : "max-h-[25px]"
                            } `}
                        src={`${feature.logo}`}
                        alt={feature.source}
                    />

                    <p>{feature.read}</p>
                </div>
            </div>
        </Link>
    );
}
